import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IAssignmentType } from "../../utils/types/models";

export default createEntityReducer<IAssignmentType>(Endpoint.AssignmentTypes, Endpoint.AssignmentTypesList);
